import type { Legal, NavLinkColumn } from './types'

export const legal_global: Legal[] = [
  {
    key: 'privacy_notice',
    name: 'Privacy Notice',
    href: '/privacy/global',
  },
  {
    key: 'status',
    name: 'Status',
    href: 'https://status.crypto.com',
  },
]

export const desktop_global: NavLinkColumn[] = [
  [
    {
      tTitle: 'products.app',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.buyAndSell',
          href: '/app',
        },
        {
          tTitle: 'products.earn',
          href: '/earn',
        },
        {
          tTitle: 'products.credit',
          href: '/credit',
        },
        {
          tTitle: 'products.pay',
          href: '/pay',
        },
      ],
    },
    {
      tTitle: 'products.cards',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.metalCards',
          href: '/cards',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.exchange',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.exchangeIndex',
          href: 'https://crypto.com/exchange',
        },
        {
          tTitle: 'products.marginTrading',
          href: 'https://crypto.com/exchange/trade/BTC_USD',
        },
        {
          tTitle: 'products.derivatives',
          href: 'https://crypto.com/exchange/trade/BTCUSD-PERP',
        },
        {
          tTitle: 'products.syndicate',
          href: 'https://crypto.com/exchange/syndicate',
        },
        {
          tTitle: 'products.supercharger',
          href: 'https://crypto.com/exchange/supercharger',
        },
        {
          tTitle: 'products.tradingArena',
          href: 'https://crypto.com/exchange/trading-arena',
        },
      ],
    },
    {
      tTitle: 'products.commerce',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.payMerchant',
          href: '/pay-merchant',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.defi',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.wallet',
          href: '/defi-wallet',
        },
        {
          tTitle: 'products.swap',
          href: 'https://crypto.com/defi/swap',
        },
        {
          tTitle: 'products.defiEarn',
          href: '/defi-wallet#earn',
        },
        {
          tTitle: 'products.dashboard',
          href: 'https://crypto.com/defi/dashboard/gas-fees',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.resources',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.prices',
          href: 'https://crypto.com/price',
        },
        {
          tTitle: 'products.siteWidgets',
          href: 'https://crypto.com/price/widget',
        },
        {
          tTitle: 'products.tax',
          href: 'https://tax.crypto.com',
        },
        {
          tTitle: 'company.support',
          href: 'https://help.crypto.com/en',
        },
        {
          tTitle: 'products.por',
          href: '/proof-of-reserves',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.learn',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'learn.trending',
          href: '/trending',
        },
        {
          tTitle: 'learn.productNews',
          href: '/product-news',
        },
        {
          tTitle: 'learn.events',
          href: '/events',
        },
        {
          tTitle: 'learn.university',
          href: '/university',
        },
        {
          tTitle: 'learn.research',
          href: '/research',
        },
        {
          tTitle: 'learn.marketUpdates',
          href: '/market-updates',
        },
        {
          tTitle: 'learn.nftStories',
          href: '/nft-stories',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.company',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'company.about',
          href: '/about',
        },
        {
          tTitle: 'company.careers',
          href: '/careers',
        },
        {
          tTitle: 'company.news',
          href: 'https://crypto.com/company-news',
        },
        {
          tTitle: 'company.security',
          href: '/security',
        },
        {
          tTitle: 'company.contact',
          href: '/about#page-contact',
        },
        {
          tTitle: 'company.capital',
          href: '/capital',
        },
        {
          tTitle: 'company.climate',
          href: 'https://crypto.com/company-news/crypto-coms-climate-commitment-2',
        },
        {
          tTitle: 'company.affiliate',
          href: '/affiliate',
        },
        {
          tTitle: 'company.partners',
          href: '/partners',
        },
        {
          tTitle: 'navbar.nft',
          href: 'https://crypto.com/nft',
          tBadgeTitle: 'navbar.new',
        },
      ],
    },
  ],
]

export const mobile_global = desktop_global
  .flatMap((menu) => menu)
  .map(({ items, ...rest }) => ({
    items: items.filter(({ tTitle }) => tTitle !== 'navbar.nft'),
    ...rest,
  }))
  .concat([
    {
      tTitle: 'navbar.nft',
      tBadgeTitle: 'navbar.new',
      href: 'https://crypto.com/nft',
      items: [],
    },
  ])
